import { BffBrandType, FacilityBrand } from '@shared-components-web/gqlConstants';
import { TagThemeType } from '@shared-components-web/types';
import { officePathByBrand } from '@shared-components-web/utils/officeURLByBrand/officeURLByBrand';

type Facility = any;

export const getFacilityDetailsUrl = (facilityBasePath: string | undefined, facilityURL: string) => {
	// need the whole url to reload the page till ODP pages are migrated
	return facilityBasePath
		? `${globalThis.location?.origin}/${facilityBasePath}/${facilityURL}/`
		: `${globalThis.location?.origin}/${facilityURL}/`;
};

export const getScheduleButtonUrl = ({
	schedulingPathFromConfig,
	facilityBrand,
	location,
}: {
	schedulingPathFromConfig: string;
	facilityBrand: FacilityBrand | BffBrandType;
	location: Facility;
}): string => {
	const platformSchedUrl = `/${schedulingPathFromConfig}/?fc=${location?.code}`;
	const platformSchedUrlWDomain = `${globalThis.location?.origin}${platformSchedUrl}`;

	if (!location.brand && (facilityBrand === FacilityBrand.AspenDental || facilityBrand === FacilityBrand.Motto)) {
		return platformSchedUrlWDomain;
	}

	if (location.brand === FacilityBrand.AspenDental || location.brand === FacilityBrand.Motto) {
		if (location?.scheduling?.schedulingUrl) {
			if (location?.scheduling?.schedulingUrl.includes('fc')) {
				return location?.scheduling?.schedulingUrl;
			}
			const separator = location?.scheduling?.schedulingUrl.includes('?') ? '&fc=' : '/?fc=';
			return location?.scheduling?.schedulingUrl?.concat(separator, location?.code);
		}
		return platformSchedUrlWDomain;
	}

	if (location.brand === FacilityBrand.WellNow) {
		return platformSchedUrl;
	}

	const baseUrl = location?.scheduling?.schedulingUrl ?? '#';
	if (baseUrl.includes('fc')) {
		return baseUrl;
	}
	const separator = baseUrl.includes('?') ? '&fc=' : '?fc=';
	return `${baseUrl}${separator}${location?.code}`;
};

export const getOfficeDetailsUrl = ({
	facilityBasePath,
	themeId,
	address,
}: {
	facilityBasePath?: string;
	themeId: TagThemeType;
	address: Facility['address'];
}): string => {
	const { stateCode: state, city, address1, zipCode } = address;
	const basePath = facilityBasePath ? `/${facilityBasePath}` : '';
	return `${basePath}/${officePathByBrand(themeId, {
		stateStrOptions: {
			stateAbbreviation: state ?? '',
			state: '',
			city: city ?? '',
		},
		cityAddressOptions: {
			city: city ?? undefined,
			address: address1?.replace(/\//g, '-') ?? undefined,
			zip: zipCode ?? undefined,
		},
	})}/`;
};
export enum RequestStatus {
	NotAsked = 'NOTASKED',
	Loading = 'LOADING',
	Success = 'SUCCESS',
	Failure = 'FAILURE',
}
